module.exports = __webpack_public_path__ + "static/media/Vector_icon.fc52c540.svg";